// uses ./AppsListItemSideload.less
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';

import { openSideloadedAppModal } from '../../sideload/sideloadActionCreators';
import customAppIcon from './custom-app-icon.png';

function AppsListItemSideload(props) {
    if (!props.actsAsAdmin || !props.userExists) {
        return null;
    }
    if (props.disableUploadingApp) {
        return null;
    }

    return (
        <div className="appsListItemSideload">
            <img src={customAppIcon} />
            <p className="appsListItemSideload-text">Create custom app</p>
            <button type="button" className="sg-button-primary" onClick={props.dispatchOpenSideloadedAppModal}>
                Create
            </button>
        </div>
    );
}

AppsListItemSideload.propTypes = {
    userExists: PropTypes.bool.isRequired,
    dispatchOpenSideloadedAppModal: PropTypes.func.isRequired,
    actsAsAdmin: PropTypes.bool.isRequired,
};

const mapDispatchToProps = {
    dispatchOpenSideloadedAppModal: openSideloadedAppModal,
};

export default connect(
    (state) => ({
        userExists: state.user.exists,
        actsAsAdmin: state.user.actsAsAdmin,
        disableUploadingApp: state.user.disableUploadingApp,
    }),
    mapDispatchToProps
)(AppsListItemSideload);
